import { cva } from 'class-variance-authority'

/** `.large-text` and its tone/alignment modifiers. */
export const largeTextVariants = cva('font-sans text-large', {
  variants: {
    tone: {
      default: 'font-normal text-font-default',
      /** `.dark` — for light text on a dark ground, per Webflow's naming. */
      dark: 'font-normal text-dark-blue-50',
      /** `.white` — note Webflow drops the weight to 200 here. */
      white: 'font-extralight text-white',
    },
    align: { left: 'text-left', center: 'text-center' },
    width: { default: '', small: 'max-w-xsmall', medium: 'max-w-medium' },
  },
  defaultVariants: { tone: 'default', align: 'left', width: 'default' },
})

/** `.mono-component-title` — small uppercase eyebrow, letter-spaced. */
export const monoTitleVariants = cva(
  'font-secondary text-small tracking-wide uppercase',
  {
    variants: {
      tone: {
        default: 'text-font-default',
        muted: 'text-font-secondary',
        white: 'text-white opacity-75',
      },
    },
    defaultVariants: { tone: 'default' },
  },
)
